/*eslint-disable*/
import ConversationApi from '../../api/communication/conversation';

export default {
    methods: {
        sendMessage(form, files) {
            this.isLoading = true;
            let formData = new FormData();
            form.users.push(this.user);
            formData.append('body', form.body);
            formData.append('grade_id', form.body);
            formData.append('name', form.name);
            formData.append('user_id', form.userId);
            formData.append('sender_id', this.user.id);
            formData.append('categories', JSON.stringify(form.users.filter(user => user.id < 0).map(category => category.type)));
            formData.append('users', JSON.stringify(form.users.filter(user => user.id > 0).map(user => user.id)));
            files.forEach((element, index) => {
                formData.append(`files[${index}]`, element);
            });
            ConversationApi.create(formData)
                .then(conversation => {
                    this.isLoading = false;
                    if (form.gradeId) {
                        window.sessionStorage.removeItem(`messageToGrade${form.gradeId}`);
                    } else if (form.userId) {
                        window.sessionStorage.removeItem(`messageToUser${form.userId}`);
                    } else {
                        window.sessionStorage.removeItem(`message`);
                    }
                    if (!conversation) {
                      return;
                    }
                }).catch(() => {
                    this.$toasted.error(this.$i18n.t('errors.message_handling'));
                    this.isLoading = false;
                });
        },
    }
}
